export default {
  sm: `
  환경은 온전하게<br>데이터는 안전하게<br>데이터센터 각 춘천
  `,
};
